import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.closeOnCancel = this.closeOnCancel.bind(this)
    this.dialogTarget.addEventListener("cancel", this.closeOnCancel)
  }

  disconnect() {
    this.dialogTarget.removeEventListener("cancel", this.closeOnCancel)
  }

  open() {
    if (this.dialogTarget.open) return

    if (this.dialogTarget.showModal) {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute("open", "")
    }
  }

  close() {
    if (this.dialogTarget.close) {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute("open")
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  closeOnCancel() {
    this.close()
  }
}
